export const roomColumns = [
  {
    Header: 'ROOM ID',
    accessor: 'hotelRoomID',
  },
  {
    Header: 'ROOM TYPE',
    accessor: 'roomType',
  },
  {
    Header: 'DESCRIPTION',
    accessor: 'description',
  },
  {
    Header: 'ACTION',
    accessor: 'actions',
    Cell: ({ value }) => value, 
  },
];


export const roomData = [
    {
    "roomNumber": "A-1101",
    "roomType": "Deluxe",
    "floor": "First Floor",
    "checkOut": "12/04/2021",
    "status": "Checkin",
    "statusColor":"text-bg-warning"
    },
    {
    "roomNumber": "A-1201",
    "roomType": "Studio",
    "floor": "First Floor",
    "checkOut": "None",
    "status": "Available",
    "statusColor":"text-bg-success"
    },
    {
    "roomNumber": "H-1001",
    "roomType": "King",
    "floor": "Eighth Floor",
    "checkOut": "None",
    "status": "Available",
    "statusColor":"text-bg-success"
    },
    {
    "roomNumber": "I-1201",
    "roomType": "Queen",
    "floor": "Nineth Floor",
    "checkOut": "None",
    "status": "Available",
    "statusColor":"text-bg-success"
    },
    {
      "roomNumber": "B-1201",
      "roomType": "Queen",
      "floor": "Nineth Floor",
      "checkOut": "None",
      "status": "Available",
      "statusColor":"text-bg-success"
    },
    {
      "roomNumber": "B-1202",
      "roomType": "Queen",
      "floor": "Nineth Floor",
      "checkOut": "None",
      "status": "Available",
      "statusColor":"text-bg-success"
    },
    {
      "roomNumber": "C-1202",
      "roomType": "Queen",
      "floor": "Nineth Floor",
      "checkOut": "None",
      "status": "Available",
      "statusColor":"text-bg-success"
    },
    {
      "roomNumber": "D-1202",
      "roomType": "Queen",
      "floor": "Nineth Floor",
      "checkOut": "None",
      "status": "Available",
      "statusColor":"text-bg-success"
    },
    {
      "roomNumber": "E-1202",
      "roomType": "Queen",
      "floor": "Nineth Floor",
      "checkOut": "None",
      "status": "Available",
      "statusColor":"text-bg-success"
    },
    {
      "roomNumber": "F-1202",
      "roomType": "Queen",
      "floor": "Nineth Floor",
      "checkOut": "None",
      "status": "Available",
      "statusColor":"text-bg-success"
    },
    
]